import { render } from "./process-area.vue?vue&type=template&id=279e6856&scoped=true"
import script from "./process-area.vue?vue&type=script&lang=js"
export * from "./process-area.vue?vue&type=script&lang=js"

import "./process-area.vue?vue&type=style&index=0&id=279e6856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279e6856"]])

export default __exports__